export const app = {
    loading: 'Now Loading Plsease Wait',
    title: 'Import Logistics System',
    manu: 'MENU',
    master: 'MASTER',
    home: 'HOME',
    system: {
        error: 'An unknown error has occurred. Please consult the IT director.'
    },
    buttons: {
        search: 'Search',
        new: 'New',
        paidNew: 'Chargeable Creation',
        unpaidNew: 'Free Creation',
        add: 'Add',
        edit: 'Edit',
        remove: 'Delete',
        confirm: 'Update',
        back: 'Back',
        csvExport: 'Export CSV',
        csvUpload: 'Upload CSV',
        save: 'Save',
        temporarySave: 'Temporary Save',
        poDetect: 'Detect P/O',
        ivUpload: 'Upload I/V',
        addFreeItems: 'Add Free Product',
        addPackages: 'Add P/L',
        plUpload: 'Upload P/L',
        sytcIvCsvUpload: 'Upload SYTC I/V CSV', // ---
        split: 'Split',
        cancelSplit: 'Cancel Split',
        splitPackage: 'Split P/L',
        apply: 'Apply',
        send: 'Send Confirm',
        fileUpload: 'Upload File',
        toNew: 'Copy ', // ----
        openEta: 'Update ETA',
        updateContainer: 'Entry Container Info',
        abolitionAndCancel: 'Cancel',
        reset: 'Reset',
        poExport: 'PO export',
        ivExport: 'Invoice export as CSV',
        export: 'Export',
        docDownload: 'Download document',
        downloadNow: 'Download address',
        videoTutorial: 'video guide DL'
    },
    labels: {
        partner: 'Partner',
        ivNo: 'I/V NO',
        poNo: 'P/O NO',
        lotNo: 'Lot NO',
        blNo: 'B/L NO',
        masterBlNo: 'Master B/L NO',
        houseBlNo: 'House B/L NO',
        loadingPort: 'Loading Port',
        classification: 'Item Classification',
        transportMode: 'Transport Mode',
        scWarehouse: 'Final Warehouse',
        warehouseKeeper: 'Warehouse Keeper',
        dischargePort: 'Discharge Port',
        incoterm: 'Incoterm',
        stackType: 'Stack Type',
        etd: 'ETD',
        eta: 'ETA',
        creationDate: 'I/V Creation Date',
        createDate: 'PO create date',
        currencyCode: 'Currency',
        productionDate: 'Production date',
        canSelect: 'Downloadable item',
        selected: 'Selected item',
        currency: 'Currency',
        grandTotal: 'I/V Amount',
        unit: 'Unit',
        chargeUnit: 'record unit',
        qty: 'Qty',
        price: 'Subtotal Amount',
        status: 'State',
        invoice: {
            item: {
                origin: 'Country Of Origin',
                unitPrice: 'FOB Unit Price',
            }
        },
        division: 'Division',
        invType: 'I/V Division',
        totalAmount: 'Total Amount',
        warehouse: 'Warehouse',
        package: {
            flag: 'Carton Label',
            cartonStartNo: 'Carton Start No',
            cartonEndNo: 'Carton End No',
            perCartonQty: 'Per Carton Qty',
            netWeight: 'N/W',
            grossWeight: 'G/W',
            volume: 'M3',
            containerNo: 'CONTAINER NO',
            containerSize: 'CONTAINER SIZE',
            totalQty: 'QTY',
            shippedCarton: 'SHIPPED CARTON',
            unitPrice: 'Unit Price'
        },
        bu: {
            name: 'Head Quarter'
        },
        department: {
            name: 'Business Department'
        },
        skuCode: 'Internal Product No',
        productCode: 'Variety',
        skuSupplierCode: 'External Product No',
        siNo: 'SI.NO',
        shippingAdvice: {
            requestDate: 'Request Date',
            blIssueDate: 'B/L Issue Date',
            exportCustomsClearanceDate: 'Export Customs Clearance Date'
        },
        forwarder: 'Forwarder',
        shipName: 'Vessel Name',
        volNo: 'Vol NO',
        customsAgent: 'Customs Agent',
        forecastDeliveryDate: 'Delivery Schedule Date',
        sjlWarehouseName: 'Delivery Warehouse',
        sort: {
            none: 'None',
            asc: 'Ascend',
            desc: 'Descend'
        },
        ctnNo: 'Container no.',
        an: 'Currency invoice',
        group: 'Group',
        forecastAcceptanceDate: 'Forecast acceptance date',
        downloadAttach: 'Download document'
    },
    validator: {
        messages: {
            required: ' is required.',
            lessThanEight: 'inv/No must less than eight'
        }
    },
    messages: {
        removeSuccess: 'Deleted',
        confirm: 'Are you sure?',
        saveSuccess: 'Saved',
        resetSuccess: 'ETA・本船名の情報を修正すると、当初登録した納入予定日が例外期間になる場合、各担当者へメール送信されます。ご了承ください。',
        fail: 'Failed',
        sent: "{type} sent",
        errors: {
            title: 'Error',
            exchangeRateNotFound: 'exchange rate has not found',
            pricingNotFound: '{chargeItem} pricing has not found',
            devanPricingRepeat: 'pricing has not found',
            insuranceRateNotFound: 'insurance rate not found',
            taxRateNotFound: 'tax rate not found',
            commissionRateNotFound: 'SJL commission rate not found',
            consumptionTaxDateIllegal: 'consumption tax Date illegal',

            exchangeRateNotFoundForQuotation: 'exchange rate has not found',
            pricingNotFoundForQuotation: '{chargeItem} pricing has not found',
            insuranceRateNotFoundForQuotation: 'insurance rate not found',
            taxRateNotFoundForQuotation: 'tax rate not found',
            commissionRateNotFoundForQuotation: 'SJL commission rate not found',

        },
        warning: {
            title: 'Warn'
        },
        success: {
            title: ''
        }

    },
    warehouseTypes: [{
            value: 'SJL',
            text: 'SJL Inbound Place'
        },
        {
            value: 'SC',
            text: 'SC Inbound Place'
        }
    ],
    screenStatisticTypes: [{
        value: '海上運賃',
        text: '海上運賃'
    }, {
        value: 'アジショナルチャージ',
        text: 'アジショナルチャージ'
    }, {
        value: '国内運賃',
        text: '国内運賃'
    }, {
        value: '国内諸掛',
        text: '国内諸掛'
    }, {
        value: '商品代金',
        text: '商品代金'
    }, {
        value: 'SJL Commission',
        text: 'SJL Commission'
    }, {
        value: '保険費',
        text: '保険費'
    }, {
        value: '搬出手数料',
        text: '搬出手数料'
    }, {
        value: '取扱料',
        text: '取扱料'
    }, {
        value: '通関料',
        text: '通関料'
    }, {
        value: 'CC.FEE',
        text: 'CC.FEE'
    }, ],
    finalWarehouseTypes: [{
            value: '11',
            text: '最終納入場所単価マスタ登録可'
        },
        {
            value: '10',
            text: '最終納入場所単価マスタ登録不可'
        },
        {
            value: '01',
            text: '最終納入場所対象外単価マスタ登録可'
        },
    ],
    unPackingObjs: [{
        value: '対象',
        text: '対象'
    }, {
        value: '対象外',
        text: '対象外'
    }],
    weekdays: 'Su,Mo,Tu,We,Th,Fr,Sa'.split(',')
}
export const M0010 = {
    title: 'ユーザーマスタ検索'
}

export const B200 = {
    messages: {
        quotationSuccess: 'quotation success',
    }
}

export const B0300 = {
    titles: [
        'INV P/L Entry',
        'Invoice Basic information',
        'Invoice Details',
        'Package List Details',
        'Add Free Product',
        'P/O Detect'
    ],
    buttons: {
        download: 'download'
    },
    messages: {
        errors: {
            checkTotal: 'The total number in {poNo} is greater than the maximum.',
            ivNoExist: 'Invoice number already exists.',
            hugeQty: 'PO残数が足りません。', //既存の数量を越えてしまいました。
            invalidQty: 'Please do not save less than 0 or greater than {qty}',
            duplicatePO: 'Duplicated P/O',
            invalidItem: 'Invoice PO can not be empty!',
            invalidPacking: 'Packing list details can not be empty!',
            invalidInvoiceItemQty: 'The number of {po} exceeds the maximum number!',
            invalidPackageQty: 'The number of packages of {po} is inconsistent!',
            notFullyPackaged: 'Not fully packaged yet!',

            buDifferent: 'Invoiceに複数事業本部のPOが入れられません。',
            qtyNotMatch: 'PO出荷数量とPOのPackingList数量が不一致のため、保存できません。',
            nw_gw_m3_require: 'N/W G/W M3が必須入力項目です。ご確認ください。',
            carton_require: 'Carton Infoを入力してください。',
            nw_gw_m3_gt0: 'N/W,G/W,M3をゼロより大きい値を入力してください',
            per_carton_qty_invalid: 'PackingListのPO数量の計算結果が間違いましたので、再度ご確認ください。（入数＊carton数＝数量）',
            paysit_not_unique: '全てのPOの支払う日付は一致しなければならない。',
            per_carton_qty_integer: '入数が整数ではないですので、再修正ください。',
            partner_unique: '海外取引先が違うため、追加できません。',
            po_not_found_upload: 'あるPOデータは存在しません。'
        },
        warning: {
            existPackagedPO: 'There are already packed POs'
        }
    },
    labels: {
        qty: 'Qty',
        incoterm: 'Incoterm',
        po: {
            qty: 'Order Qty',
            leftInvoice: 'Order Remainder Qty'
        }
    }
}
export const B0400 = {
    titles: [
        'Shipping Advice',
        'Shipping Information',
        'Container Information',
        'CONTAINER NO',
        'Update ETA',
        'I/V List'
    ],
    title: 'Shipping Advice',
    messages: {
        modifyEta: 'Correcting the ETA Vessel Name information will reset the information on the scheduled delivery date and the delivery schedule place, so is it OK?',
        errors: {
            invalidPort: 'Since S/A\'s Loading Port/Discharge Port does not match the Loading Port/Discharge Port of INV, please confirm again!',
            invalidBlNo: 'B/L No. Can\'t repeated',
            invalidContainerInfo: 'Container information is incomplete!',
            invalidInvoice: 'Selected inv already exists.',

            package_qty_over: 'SA package qty can not more than INV qty.',
            do_confirmed: 'The DO can not update as it was confirmed.',
            package_required: 'Package info can not empty.',
            ctn_no_save_type_diff: 'CTN type must same as same name.',
            per_carton_qty_invalid: 'Please check packing qty with formula:[per carton qty ＊carton qty＝qty total]', //「入数＊carton数＝数量」ルールを守ってください。
            nw_gw_m3_require: 'N/W G/W M3 are require。',
            nw_gw_m3_gt0: 'N/W,G/W,M3 must more than 0。',
            sa_status_invalid: 'S/A取消してください。',
            inv_canceled: 'I/V取消してください',
            do_not_relieve: 'DO解除していない、或いはDO解除確認していない',
            paysit_not_unique: 'The payment date for all PO must match.',
            pay_inv_require: 'Unpay INV must with payed INV when SA create.',
            source_conflict: 'SA can not combine SAP with PF INV.',
            inv_bu_unique: 'Invoice BU info must unique.',
            m3_more_than_100: 'm3 more than 100'

        },
        success: {
            sendSuccess: 'SA Sent',
            completed: 'Completed',

            cancel_success: 'SA cancel success.'
        }
    },
    labels: {
        flightNo: 'Flight NO',
        voyageNo: 'VOYAGE NO',
        siNo: 'S/I NO'
    }
}

export const B0500 = {
    messages: {
        error: '発注者がユーザーＩＤに存在しないため、メールが送信されませんでした。該当のPOは次の階段に進めませんでした。'
    }
}

export const B0800 = {
    messages: {
        noPattern: 'Please set pattern first.',
        noChargeConfirm: 'Please confirm DO Fee first.',
        doConfirmed: 'This DO already confirmed.',
        doRelieving: 'This DO unable confirm as it is relieving.',
        doNoEmpty: 'This DO unable confirm as the DO NO. is empty.',
        blNoDuplicate: 'The bl NO. is duplicate.',
        exchangeRateNotFound: 'Exchange rate can not find.',
        productNotFound: 'The sku can not find product.',
        noWhsManager: 'The warehouse manager is empty.',
        doSuccessConfirm: 'D/O confirmed success.',
        noFreightCharge: 'This DO unable confirm as the freight fee is empty.',
        unableRelieve: 'This DO unable relieve.',
        relieveSuccess: 'DO relieve success.',
        select_one: '一つのD/Oデータをチェックしてください。',
        unableRelieveConfirm: 'This DO unable relieve confirm as it is not in relieving.'
    }
}

export const B1000 = {
    messages: {
        errors: {
            doHasConfirmed: 'DO has been confirmed'
        }
    }
}

export const B1300 = {
    title: 'Status inquiry',
    buttons: {
        eiaj: 'Variety of Model',
        eta: 'Estimated Time of Arrival over 1 week',
        sytc: 'Receiving proposal',
        warehouseCtn: 'Container no. per warehouse category',
        byMonth: 'Delivery schedule by month',
        mother: 'DO parent company',
        child: 'DO branch unit'
    },
    labels: {
        status: 'Status',
        warehousingDate: 'Latest delivery instruction date',
        operatorId: 'Operator ID',
        ctnSize: 'Container size',
        warehousingTime: 'Receipt instruction time',
        forecastDeliveryTime: 'Latest receipt time',
        finallyWarehouseName: 'Warehouse name',
        drakeCompanyName: 'Warehouse arrangement',
        date1: 'Sales processing day',
        date2: 'Paycheck day',
        branchCode: 'Branch'
    }
}

export const B1500 = {
    title: 'PO inquiry',
    labels: {
        status: 'Status',
        isLeftInvoice: 'Have invoice remain',
        leftInvoice: 'Invoice remain qty',
        qty: 'Order qty',
        unitPrice: 'Order unit price',
        subTotal: 'Order amount',
        finishedQty: 'SA finished qty',
        createdInvoice: 'Invoice created successfully',
        leftSupply: 'Receipt remaining',
        orderName: 'Orderer name'
    },
    messages: {
        errors: {
            checkLeftInvoice: 'Since there has no remaining invoice of PO, cannot export',
            hasDifBu: 'Can the PO from business headquarter been input?'
        }
    }
}

export const menus = {
    M0010: 'ユーザー',
    M0020: '権限',
    M0030: '企業',
    M0040: '部所（事業本部、事業部）',
    M0050: '計上単位',
    M0060: '建値（支払条件）',
    M0070: '地域',
    M0080: '港',
    M0090: '納入場所',
    M0100: '為替レート',
    M0110: 'コンテナ種別',
    M0120: 'チャージトラック種別',
    M0130: '費用単価（タリフ）',
    M0140: '保険費レート',
    M0150: '通関費用',
    M0160: '品番',
    M0230: '品種',
    M0170: '納入場所グループ',
    M0180: '運送形態',
    M0190: '消費税税率',
    M0200: '国内配送パターン',
    M0210: '基本コミッション',
    M0220: '費用項目',
    M0250: 'その他諸掛',
    M0300: 'ロングドレー判定テーブル',

    B0300: 'INV P/L Entry',
    B0400: 'Shipping Advice',
    B1600: 'BL確認完了送信',
    B0500: '納入指示メール配信',
    B0600: '納入指示',
    B0700: '受入確認',
    B1000: 'フレイトI/V作成',
    B0800: 'D/O確定',
    B0900: 'EIAJ',
    B1100: '諸掛費用登録',
    B1200: '月次処理・請求',
    B1201: '月次処理・請求',
    B1400: '売掛金回収',
    B1601: 'BL確認完了照会',
    B2000: '月次運賃ハンド対応一覧'
    // B1800: 'PO変更・取消一覧',
    // B1900: 'PreSA・本SA相違一覧',

}